import { observable, reaction } from "mobx";
import { wordPressService } from "../../../../cdm/services/wordpress-service";
import { endpointConfig } from "../../../../config/api-config";
import { stateController } from "../../../../cdm/controllers/state-controller";
import { asyncPause } from "../../../../utils/helpers";

export class GroupJobPostingListController {
  @observable loading = false;
  frameUrl = "";

  constructor(props) {
    this.props = props;
    this._initialize();
    reaction(() => stateController.viewGroupId, () => this._initialize());
  }

  _initialize = () => {
    wordPressService.setWpHostname(endpointConfig.job_posting_hostname);
    this.frameUrl = `${window.location.protocol}//${
      endpointConfig.job_posting_hostname
    }/jobs/senior-caregiver/manage?group=${
      stateController.viewGroupId
    }&hideHero=true&hideBody=true`;
  };
}
